import Smartphones from 'Reports/views/TaxPaymentReport/TaxPaymentReportView/containers/Smartphones'
import Tablets from 'Reports/views/TaxPaymentReport/TaxPaymentReportView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TodoView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoView
